import { render } from "./PhysicalPaymentInstructions.vue?vue&type=template&id=32d4698e&scoped=true"
import script from "./PhysicalPaymentInstructions.vue?vue&type=script&lang=js"
export * from "./PhysicalPaymentInstructions.vue?vue&type=script&lang=js"

import "./PhysicalPaymentInstructions.vue?vue&type=style&index=0&id=32d4698e&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d4698e"]])

export default __exports__